import { InputLabel, styled } from '@mui/material';

export const NetZeroLabelStyles = styled(InputLabel)({
  width: '100%',
  minWidth: 350,
  textAlign: 'right',
  whiteSpace: 'inherit',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  '&& .MuiInputLabel-asterisk': {
    whiteSpace: 'nowrap',
  },
});
